module.exports = __webpack_public_path__ + "static/img/shou-sheng-qian.ab2a5f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/shou-sheng-qian.jpg
// module id = LC92
// module chunks = 1